import { createRouter, createWebHistory, RouteRecordRaw, RouterScrollBehavior } from 'vue-router'
import Home from '../views/Home.vue'
import Search from '../views/Search.vue'
import Results from '../views/Results.vue'

import Basket from '../views/Basket.vue'
import Pay from '../views/Pay.vue'
import PayResult from '../views/PayResult.vue'
import PaySuccess from '../views/PaySuccess.vue'
import PayDeclined from '../views/PayDeclined.vue'
import PayCanceled from '../views/PayCanceled.vue'
import PayException from '../views/PayException.vue'

import Register from '../views/Register.vue'
import RegisterActivationNotice from '../views/RegisterActivationNotice.vue'
import RegisterActivate from '../views/RegisterActivate.vue'

import Login from '../views/Login.vue'
import LoginFinish from '../views/LoginFinish.vue'
import ForgottenPassword from '../views/ForgottenPassword.vue'
import ForgottenPasswordConfirm from '../views/ForgottenPasswordConfirm.vue'

import Account from '../views/Account.vue'
import AccountUpdateEmail from '../views/AccountUpdateEmail.vue'
import AccountUpdatePassword from '../views/AccountUpdatePassword.vue'

import PasswordReset from '../views/PasswordReset.vue'

import Orders from '../views/Orders.vue'

import Help from '../views/Help.vue'
import Cookies from '../views/Cookies.vue'
import Releases from '../views/Releases.vue'
import NotFound from '../views/NotFound.vue'
import store from '../store'

const routes: Array<RouteRecordRaw> =
[
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/advanced-search',
        name: 'Search',
        component: Search,
        beforeEnter: (to, from, next) =>
        {
            const stage1Data = store.getters['formData/stage1Exists']
            if(!stage1Data)
            {
                next({ name: 'Home' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/search-results',
        name: 'Results',
        component: Results,
        beforeEnter: (to, from, next) =>
        {
            const stage2Data = store.getters['formData/stage2Exists']
            if(!stage2Data)
            {
                next({ name: 'Search' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/basket',
        name: 'Basket',
        component: Basket
    },
    {
        path: '/payment',
        name: 'Pay',
        component: Pay
    },
    {
        path: '/payment/result',
        name: 'PayResult',
        component: PayResult
    },
    {
        path: '/payment/success',
        name: 'PaySuccess',
        component: PaySuccess
    },
    {
        path: '/payment/declined',
        name: 'PayDeclined',
        component: PayDeclined
    },
    {
        path: '/payment/canceled',
        name: 'PayCanceled',
        component: PayCanceled
    },
    {
        path: '/payment/exception',
        name: 'PayException',
        component: PayException
    },
    {
        path: '/create-an-account',
        name: 'Register',
        component: Register
    },
    {
        path: '/create-an-account/activate',
        name: 'RegisterActivationNotice',
        component: RegisterActivationNotice,
        beforeEnter: (to, from, next) =>
        {
            const registrationData = store.getters['formData/registrationExists']
            if(!registrationData)
            {
                next({ name: 'Register' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/account/activate',
        name: 'RegisterActivate',
        component: RegisterActivate
    },
    {
        path: '/sign-in',
        name: 'Login',
        component: Login
    },
    {
        path: '/sign-in/complete',
        name: 'LoginFinish',
        component: LoginFinish,
        beforeEnter: (to, from, next) =>
        {
            const loginData = store.getters['formData/loginExists']
            if(!loginData)
            {
                next({ name: 'Login' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/forgotten-password',
        name: 'ForgottenPassword',
        component: ForgottenPassword,
        beforeEnter: (to, from, next) =>
        {
            const loginData = store.getters['formData/loginExists']
            if(!loginData)
            {
                next({ name: 'Login' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/account/resetpassword',
        name: 'ForgottenPasswordConfirm',
        component: ForgottenPasswordConfirm,
        beforeEnter: (to, from, next) =>
        {
            if(to.query.g === undefined || !to.query.g)
            {
                next({ name: 'ForgottenPassword' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/manage-account',
        name: 'Account',
        component: Account,
        beforeEnter: (to, from, next) =>
        {
            redirectWithoutAuthentication(next, 'Home')
        }
    },
    {
        path: '/manage-account/update-email',
        name: 'AccountUpdateEmail',
        component: AccountUpdateEmail,
        beforeEnter: (to, from, next) =>
        {
            redirectWithoutAuthentication(next, 'Home')
        }
    },
    {
        path: '/manage-account/update-password',
        name: 'AccountUpdatePassword',
        component: AccountUpdatePassword,
        beforeEnter: (to, from, next) =>
        {
            redirectWithoutAuthentication(next, 'Home')
        }
    },
    {
        path: '/password-reset',
        name: 'PasswordReset',
        component: PasswordReset,
        beforeEnter: (to, from, next) =>
        {
            const registrationData = store.getters['formData/passwordResetExists']
            if(!registrationData)
            {
                next({ name: 'Account' })
            }
            else
            {
                next()
            }
        }
    },
    {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        beforeEnter: (to, from, next) =>
        {
            redirectWithoutAuthentication(next, 'Home')
        }
    },
    {
        path: '/help',
        name: 'Help',
        component: Help
    },
    {
        path: '/help/cookies',
        name: 'Cookies',
        component: Cookies
    },
    {
        path: '/help/release-notes',
        name: 'Release notes',
        component: Releases
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, props: true }
]

function redirectWithoutAuthentication(next: (routeName: Record<string, string> | void) => void, routeName: string)
{
    const isAuthenticated = store.getters['auth/isAuthenticated']
    if(!isAuthenticated)
    {
        next({ name: routeName })
    }
    else
    {
        next()
    }
}

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) =>
{
    if(to.params.noScroll !== undefined)
    {
        return false
    }
    if(to.hash)
    {
        return { el: to.hash, behavior: 'smooth' }
    }
    if(savedPosition)
    {
        return savedPosition
    }
    return { left: 0, top: 0, behavior: 'smooth' }
}

const router = createRouter(
{
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior
})

router.beforeEach((to, from, next) =>
{
    // Clear search form where appropriate:
    if(to.params.clearSearch !== undefined && to.params.clearSearch === 'true')
    {
        store.commit('formData/resetStageData')
    }
    // Set back button where appropriate:
    if(to.params.back !== undefined)
    {
        store.commit('routing/setBackButton', to.params.back)
    }
    else if(to.name === 'Search')
    {
        store.commit('routing/setBackButton', 'Home')
    }
    else if(to.name === 'Results')
    {
        store.commit('routing/setBackButton', 'Search')
    }
    else
    {
        store.commit('routing/hideBackButton')
    }
    // Reset errors:
    if(from.name !== to.name)
    {
        store.commit('errors/resetFormErrors')
        store.commit('errors/resetNuxeoErrors')
        store.commit('confirmations/resetConfirmationData')
    }
    // Go to route:
    next()
})

export default router
